import OffcanvasMap from "./offcanvas-map";
export default OffcanvasMap;